<template>
  <main class="min-h-screen bg-gray-50">
    <div class="mx-auto max-w-5xl px-4 py-8">
      <div class="mb-6 flex items-center justify-between">
        <div>
          <p class="mb-2 text-xs font-semibold uppercase text-red-500">{{ t('Конфиденциально и бережно') }}</p>
          <h1 class="text-3xl font-semibold text-gray-900">{{ t('ARQAU · Опросники') }}</h1>
          <p class="mt-1 text-sm text-gray-500">{{ t('Пройдите оценку своего состояния без регистрации') }}</p>
        </div>
      </div>

      <div class="mb-5 flex gap-2">
        <button
          v-for="option in languages"
          :key="option.value"
          class="rounded-md px-3 py-2 text-sm"
          :class="language === option.value ? 'bg-blue-600 text-white' : 'bg-white text-gray-700'"
          @click="language = option.value; loadSurveys()"
        >
          {{ option.label }}
        </button>
      </div>

      <div v-if="loading" class="rounded-lg bg-white p-8 text-center text-gray-500">{{ t('Загрузка...') }}</div>
      <div v-else-if="error" class="rounded-lg bg-red-50 p-8 text-center text-red-700">{{ error }}</div>
      <div v-else-if="surveys.length === 0" class="rounded-lg bg-white p-8 text-center text-gray-500">
        {{ t('Сейчас нет доступных опросов') }}
      </div>

      <div v-else class="grid gap-4 md:grid-cols-2">
        <article v-for="survey in surveys" :key="survey.id" class="rounded-lg bg-white p-5 shadow-sm">
          <div class="mb-3 flex items-center gap-2">
            <span class="rounded-full bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700">{{ survey.language.toUpperCase() }}</span>
            <span v-if="survey.is_repeatable" class="rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700">
              {{ t('Повторяемый') }}
            </span>
          </div>
          <h2 class="text-lg font-semibold text-gray-900">{{ survey.name }}</h2>
          <p v-if="survey.description" class="mt-2 text-sm text-gray-600">{{ survey.description }}</p>
          <div class="mt-4 flex items-center justify-between text-sm text-gray-500">
            <span>{{ survey.question_count || 0 }} {{ t('вопросов') }}</span>
            <router-link :to="`/surveys/${survey.id}`" class="rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700">
              {{ t('Пройти') }}
            </router-link>
          </div>
        </article>
      </div>
    </div>
  </main>
</template>

<script>
import api from '@/services/api'
import { t } from '@/i18n'

export default {
  name: 'AvailableSurveys',
  data() {
    return {
      surveys: [],
      loading: false,
      error: '',
      language: 'ru',
      languages: [
        { value: 'ru', label: 'Русский' },
        { value: 'kz', label: 'Қазақша' }
      ]
    }
  },
  created() {
    this.loadSurveys()
  },
  methods: {
    t,
    async loadSurveys() {
      this.loading = true
      this.error = ''
      try {
        const response = await api.getAvailableSurveys(this.language)
        this.surveys = response.data || []
      } catch (error) {
        this.error = error.response?.data?.error || t('Не удалось загрузить опросы')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
